import angular from "angular";

angular.module("ticketco/ticketbuyer/gift_cards", [
  "ticketco/ticketbuyer/common",
]);
